// extracted by mini-css-extract-plugin
module.exports = {"customHeight":"Body_customHeight__x3avK","focusBtn__mobile":"Body_focusBtn__mobile__hfwIj"};